import { UnifiedDialog } from "../../shared/ui";
import { Center, Slider, Stack, Text } from "@mantine/core";
import { IconGripVertical } from "@tabler/icons-react";
import styles from "./style.module.scss";
import { useUnit } from "effector-react";
import { setSimilarityFilterModel } from "./model";
import { useEffect, useState } from "react";

export const SimilarityChooseModal = () => {
  const [inputValue, setInputValue] = useState(80);

  const { opened, close, submit, currentSimilarity } = useUnit({
    opened: setSimilarityFilterModel.opened,
    close: setSimilarityFilterModel.close,
    submit: setSimilarityFilterModel.submit,
    currentSimilarity: setSimilarityFilterModel.$currentSimilarity,
  });

  useEffect(() => {
    setInputValue(currentSimilarity);
  }, [currentSimilarity]);

  return (
    <UnifiedDialog
      opened={opened}
      onClose={close}
      title="Set Similarity"
      body={
        <Stack h="170">
          <Text size="sm" fw={500}>
            Choose the similarity threshold for the articles.
          </Text>
          <Center>
            <Slider
              w={322}
              my="xl"
              step={1}
              classNames={styles}
              labelAlwaysOn
              min={80}
              max={100}
              marks={[
                { value: 80, label: 'Broader Match' },
                { value: 90, label: 'Focused Match' },
                { value: 100, label: 'Precise Match' },
              ]}
              onChange={(value) => setInputValue(value)}
              defaultValue={inputValue}
              thumbChildren={<IconGripVertical size={20} stroke={1.5} />}
            />
          </Center>
        </Stack>
      }
      okText="Save"
      onOk={() => submit({ similarity: inputValue })}
      cancelText="Cancel"
      onCancel={close}
    />
  );
};
